module.exports = __webpack_public_path__ + "supplier/img/login_img_top2x.5ef3b0eb.png";